<script>
export default {
  props: {
    groupClasses: {
      default: ''
    },
    id: {
      default: ''
    },
    hasError: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<template>
  <div :class="{
    'row form-group': true,
    [groupClasses]: groupClasses,
  }">
    <label v-if="$slots.label" :class="{'col-lg-4 col-xxl-3 col-form-label': true, 'text-danger': hasError}" :for="id">
      <slot name="label"/>
    </label>

    <div class="ms-auto col-lg-8 col-xxl-9">
      <slot/>
    </div>
  </div>
</template>
